<template>
  <div>
    <el-row v-if="reRenderComp">
      <el-col :span="9" class="text-left">
        <span class="quantity-label">{{
          $t("products.addToCart.label.quantity")
        }}</span>
        <div>
          <el-input-number class="add-to-cart-qty" v-model="model.qty" :min="1" style="width: 50px" :controls="false" />
          <span class="nb-item-label light-grey" v-if="type != 'boutique'">
            <label v-if="Number(uvc) > 1"> {{ $t("products.caisse") }} (x{{ uvc }}) </label>
            <label v-else >{{ $t("products.units") }} </label>
          </span>
          <span v-if="countryCode == 'QC' && inventoryLabel" class="inventory__label inventory">
            {{ inventoryLabel }}
          </span><br />
          <span class="volume">{{ getVolume }}</span>
        </div>
      </el-col>
      <el-col :span="15" class="text-right cart-section">
        <span class="price-label">
          {{ priceLabel }}
          <span v-if="taxIn"> ({{ taxLabel }})</span>
          <span v-else> ({{ taxLabel }})</span>
        </span>
        <div class="price-volume">
          <span class="price" v-html="price"></span>
          <!-- Per-unit hint shown when products are sold individually (uvc=1),
            so customers don't wonder whether the listed price is per case. -->
          <span v-if="Number(uvc) === 1" class="each-label light-grey">
            {{ $t("products.each") }}
          </span>
        </div>
        <div>
          <el-button v-if="getSAQProduct == 'SAQ' && !notAvailableProduct" :type="btnType"
            :class="['mt-20', btnType == 'warning' ? 'add-to-cart-btn' : '']" style="height: 35px; line-height: 1;"
            @click="buyProduct">
            {{ buyLabel }}
          </el-button>
          <el-button v-else-if="getSAQProduct != 'SAQ' && !notAvailableProduct" :type="btnType"
            :class="alreadyReserved ? 'not-available' : 'mt-20'" style="height: 35px; line-height: 1"
            @click="reserveProduct ? showAddToCartPopup() : addToCart($event)">
            {{ addToCartLabel }}
          </el-button>
          <el-button v-else-if="notAvailableProduct" :type="btnType" class="mt-20 not-available"
            style="height: 35px; line-height: 1">
            {{ addToCartLabel }}
          </el-button>
        </div>

        <div class="add-to-cart__content flex mt-7 purchaseLabel" v-if="type == 'boutique'">
          <QuestionMark style="margin-left: auto" />
          <el-link ref="link" type="warning" class="label add-to-cart__label ml-3">
            {{ purchaseLabel }}
          </el-link>
        </div>
        <div class="mt-7 purchaseLabel" v-if="type == 'boutique'">
          <el-link ref="link" type="warning" class="label add-to-cart__label ml-3">
            {{ purchaseLabelMember }}
          </el-link>
        </div>
        <div style="display: flex; align-items: baseline; justify-content: end; gap: 3px;"
          class="add-to-cart__content flex mt-7" v-if="productType == 'agency'">
          <el-popover placement="top-start" title="" width="500" trigger="hover"
            :hide="hideShowpopup(howToOrderLabelDesc)" :popperClass="hideShowPopupModel">
            <div v-html="howToOrderLabelDesc"></div>
            <el-link ref="link" type="primary" class="label add-to-cart__label ml-3" slot="reference" v-if="countryCode == 'QC'">
              <QuestionMark class="questionMark" style="" />
            </el-link>
          </el-popover>
          <el-link type="primary" class="label add-to-cart__label ml-3 questionMark" v-if="countryCode == 'QC'">{{ howToOrderLabel }}</el-link>
        </div>
      </el-col>
      <el-dialog class="add-to-cart-modal" :visible.sync="addToCartPopup" :header="false" width="669px">
        <h3 v-if="!reserveProduct && addToCartPopupContent" class="add-to-cart-title text-left text-uppercase mb-20">
          <i class="el-icon-success mr-5 success-icon"></i>{{ $t("products.addToCartPopup.title") }}
        </h3>
        <div v-if="reserveProduct && addToCartPopupContent" class="mb-20">
          <h3 class="add-to-cart-title text-left text-uppercase ">
            <i class="el-icon-success mr-5 success-icon"></i>{{ $t("products.reservePopup.title") }}
          </h3>
          <p class="ml-5">{{ $t("products.reservePopup.subtitle") }}</p>
        </div>
        <el-row v-if="addToCartPopupContent">
          <el-col :xs="24" :sm="24" :md="8" style="background-color: rgba(237, 240, 237, 0.33)">
            <el-image class="d-flex" style="height: 250px" :src="productImage" :fit="'contain'">
            </el-image>
          </el-col>
          <el-col :xs="24" :sm="24" :md="16" class="pl-10">
            <h5 class="product-name mb-5">
              {{ product && product.name }}
            </h5>
            <div class="flex">
              <span class="subtitle2 light-grey provider">{{ provider }}</span>
              <el-image v-if="isBiologique != ''" class="biologique-logo ml-5 mb-5" :src="isBiologique"
                :fit="'contain'" />
            </div>
            <span class="subtitle2 light-grey"> {{ origin }}</span>
            <div class="price-section">
              <span class="price" v-html="price"></span>
              <span v-if="getRoute != 'STORE_MTL' && getRoute != 'STORE_TORONTO'" class="nb-item-label light-grey">
                <label v-if="Number(uvc) > 1">  {{ $t("products.caisse") }} (x{{ uvc }})</label>
                <label v-else >{{ $t("products.units") }}</label>
              </span>
              <span v-if="getRoute != 'STORE_MTL' && getRoute != 'STORE_TORONTO'" class="inventory pl-3 pr-3 d-none"> IP
              </span>
            </div>
          </el-col>
          <el-col>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" class="text-right">
            <el-link class="continue-shopping mr-10" @click="addToCartPopup = false" :underline="false">
              {{ reserveProduct ? $t("products.reservePopup.cancelButton") : $t("products.addToCartPopup.shopping") }}
            </el-link>
            <el-button :type="btnType" :class="['mt-10', btnType == 'warning' ? 'add-to-cart-btn' : '']"
              style="height: 35px; width: 203px; line-height: 1"
              @click="!reserveProduct ? goToShopping('/shopping-cart') : showreservePopup()">
              {{ reserveProduct ? $t("products.reservePopup.reserveButton") : $t("products.addToCartPopup.seeCart") }}
            </el-button>
          </el-col>
        </el-row>
        <el-row v-if="showReservationThanks">
          <div>
            <h3 class="add-to-cart-title text-left text-uppercase">
              <i class="el-icon-success mr-5 success-icon"></i>
              {{ $t("products.addToCartPopup.thanksMessage") }}
            </h3>
            <p class="ml-5">
              {{ $t("products.addToCartPopup.reserveContent") }}
            </p>
          </div>
        </el-row>
      </el-dialog>
    </el-row>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { get, isEmpty, filter, head } from "@/utils/lodash";
import { formatCurrency, specialFormatCurrency } from "@/utils/common-utils";

import QuestionMark from "@/components/question-mark.vue";
import imgProductDefault from "@/assets/images/product/product-default.png";
import imgProductLeaf from "@/assets/images/product/leaf.png";
import imgProductMoon from "@/assets/images/product/moon.png";
import { reportError } from "@/utils/error-reporter";
import { getDefaultAvailability, isBoutiqueInventory } from "@/utils/market-utils";

export default {
  name: "AddToCart",
  components: {
    QuestionMark,
  },
  props: {
    product: {
      type: Object,
      default: () => { },
    },
    taxCode: {
      type: String,
      default: "IN",
    },
    productType: {
      type: String,
      default: "agency",
    },
    type: {
      type: String,
      default: "",
    },
    getBotiqueProduct: {
      type: Array,
      default: () => [],
    },
    getAgencyProduct: {
      type: Array,
      default: () => [],
    },
    inventoryType: {
      type: String,
      default: "agency",
    },
  },
  data() {
    return {
      model: {
        qty: 1,
      },
      btnType: this.productType == "agency" ? "primary" : "warning",
      defaultStore: this.$i18n.t("products.boutiqueList.titleRestro"),
      showBotiqueList: false,
      addToCartPopup: false,
      addToCartPopupContent: false,
      images: {
        productDefault: {
          src: imgProductDefault,
        },
      },
      productMoonImg: imgProductMoon,
      productLeafImg: imgProductLeaf,
      addToCartBtnLabel: this.$i18n.t("products.addToCart.label.addToCart"),
      activeAddToCartBtn: true,
      hideShowPopupModel: "",
      reRenderComp: true,
      isToronto: this.$route.query.productType === 'STORE_TORONTO',
      getRoute: this.$route.query.productType,
      countryCode: localStorage.getItem("countryCode") == 'QC' ? 'QC' : 'ON',
      reserveProduct: false,
      showReservationThanks: false,
      reservedProductIds: [],
      alreadyReserved: false,
    };
  },
  computed: {
    // Derived from current product data so it always reflects live stock.
    // Previously this was a data flag set as a side-effect inside
    // addToCartLabel while erp stock was still loading (undefined >= uvc is
    // false); it was never reset, so in-stock products were left showing the
    // dead "not available" button and could not be ordered.
    notAvailableProduct() {
      const inStock = get(this.product, "erpProduct.quantity.inStock");
      if (inStock == null) return false;
      if (inStock >= get(this.product, "uvc")) return false;
      if (get(this.product, "erpProduct.itemToCome.receptionPlanningDate")) return false;
      return true;
    },
    ...mapState("shoppingCart", ["shoppingCart"]),
    ...mapState("user", ["user"]),
    ...mapGetters("user", ["isLoggedIn"]),
    getSAQProduct() {
      const productData = get(this.product, "inventory.code");
      return productData;
    },
    uvc() {
      const uvc = get(this.product, "uvc");
      return uvc;
    },
    taxIn() {
      return this.taxCode === "IN";
    },
    price() {
      let price = get(this.product, "erpProduct.pricing.price", get(this.product, "pricing.price", 0));
      let agencyFees = get(this.product, "erpProduct.pricing.agencyFee", get(this.product, "pricing.agencyFee", 0));
      if (this.taxCode === "IN") {
        price = get(this.product, "erpProduct.pricing.priceTaxIn", get(this.product, "pricing.priceTaxIn", 0));
        if (price === 0 || price == null)
          price = get(this.product, "erpProduct.pricing.price", get(this.product, "pricing.price", 0));
          agencyFees = get(this.product, "erpProduct.pricing.agencyFeeBasedOnTaxInWTaxes", get(this.product, "pricing.agencyFeeBasedOnTaxInWTaxes", 0));
      }

      if (price + agencyFees === 0) {
        return "";
      }
      if (this.$i18n.locale == "fr-CA" || this.$i18n.locale == "en-US") {
        var formatPrice = specialFormatCurrency(
          price + agencyFees,
          this.$i18n.locale
        );
        if (this.$i18n.locale == "en-US") {
          formatPrice = formatPrice.split(".");
        } else {
          formatPrice = formatPrice.split(",");
        }

        if (formatPrice.length == 1) {
          formatPrice.push("00");
        }
        return `${formatPrice[0]
          }<sup style="font-size: 10px; line-height: 2; vertical-align: 5px;"> ${formatPrice[1]
            .toString()
            .padEnd(2, "0")}</sup> $`;
      }

      return formatCurrency(price + agencyFees, this.$i18n.locale);
    },
    taxLabel() {
      return this.$i18n.t(`products.addToCart.title.taxLabel.${this.taxCode}`);
    },
    priceLabel() {
      return this.$i18n.t("products.addToCart.title.price");
    },
    buyLabel() {
      return this.$i18n.t("products.addToCart.label.buy");
    },
    addToCartLabel() {
      let getProducts = get(this.shoppingCart, "products");
      const productPuid = this.product.puid || get(this.product, "erpProduct.puid");
      if (get(this.product, "erpProduct.quantity.inStock") >= get(this.product, "uvc")) {
        var checkProduct = filter(
          getProducts,
          (p) =>
            p.puid != null &&
            p.puid ===
            (!this.product.puid
              ? this.product.erpProduct.puid
              : this.product.puid)
        );
        if (!isEmpty(checkProduct) && this.activeAddToCartBtn) {
          return this.$i18n.t("products.addToCart.label.addedToCart");
        }
        return this.$i18n.t("products.addToCart.label.addToCart");
      }
      if (get(this.product, "erpProduct.itemToCome.receptionPlanningDate")) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.reserveProduct = true;
        const isReserved = this.reservedProductIds.includes(productPuid);
        if (isReserved) {
          this.reservedProduct();
          return this.$i18n.t("products.addToCart.label.reserved");
        }
        return this.$i18n.t("products.addToCart.label.reserve");
      }
      return this.$i18n.t("products.addToCart.label.notAvailable");
    },
    howToOrderLabel() {
      return this.$i18n.t("products.addToCart.label.howToOrder");
    },
    availableInStoreLabel() {
      return this.$i18n.t("products.addToCart.label.availableInStore");
    },
    purchaseLabel() {
      return this.$i18n.t("products.addToCart.label.purchase");
    },
    purchaseLabelMember() {
      return this.$i18n.t("products.addToCart.label.purchaseMember");
    },
    howToOrderLabelDesc() {
      return this.$i18n.t("products.addToCart.labelDescription.howToOrder");
    },
    pickupInsaqDesc() {
      return this.$i18n.t("products.addToCart.labelDescription.pickupInsaq");
    },
    available() {
      return get(this.product, "erpProduct.quantity.available");
    },
    availableLabel() {
      return this.$i18n.t("products.productView.label.privateAvailable");
    },
    notAvailableLabel() {
      return this.$i18n.t("products.productView.label.privateNotAvailable");
    },
    agencyAvailable() {
      return !isEmpty(this.getAgencyProduct) ? true : false;
    },
    productImage() {
      const pImage = get(this.product, "image.link");

      if (pImage == null) {
        return this.images.productDefault.src;
      }

      return pImage;
    },
    provider() {
      const aliasName = get(this.product, "cmsProvider.aliasName");

      return isEmpty(aliasName)
        ? get(this.product, "cmsProvider.name")
        : aliasName;
    },
    isBiologique() {
      var product = get(this.product, "attributes");
      if (product) {
        const filtered = filter(
          product,
          (p) => p.code !== null && p.code === "BIO"
        );
        if (!isEmpty(filtered)) {
          return this.productLeafImg;
        }
        const filteredB = filter(
          product,
          (p) => p.code !== null && p.code === "BIODYNAMICS"
        );
        if (!isEmpty(filteredB)) {
          return this.productMoonImg;
        }
        return "";
      }
      return "";
    },
    origin() {
      const originHead = head(get(this.product, "origins"));
      const country = get(originHead, "country.name");
      const region = get(originHead, "region.name");

      return originHead && `${region == null ? "" : region}, ${country}`;
    },
    SaqPick() {
      return this.$i18n.t("products.SaqPick");
    },
    getVolume() {
      let volume = get(this.product, "volume", 0);
      let format = get(this.product, "format", 1);
      if (volume) {
        format = format == 1 ? "ml" : "l";
        volume = `${volume} ${format}`;
      } else {
        volume = "";
      }
      return volume;
    },
    inventoryLabel() {
      var inventory = get(this.product, "inventory.code");
      const inventoryMapping = this.countryCode == 'ON' ?
        {
          IP: "CSMT",
          // SAQ: "LCBO",
          LCBO: "LCBO",
          STORE_TORONTO: "DIR",
          MERCH_TORONTO: 'DIR',
          PI: "DIR",
          Consignment: "PRI",
          null: "CSMT",
        } :
        {
          IP: "IP",
          SAQ: "SAQ",
          STORE_MTL: "DIR",
          BERGEVILLE: "DIR",
          Brouhh: "DIR",
          MERCH_MTL: "DIR",
          null: "",
        };
      return inventoryMapping[inventory] || "";
    },
    getDisableProducts() {
      const findDisabled = this.getBotiqueProduct.every(p => p.disabled);
      return findDisabled;
    }
  },
  created() {
    // const shoppingCartId =
    //   get(this.shoppingCart, "id") || localStorage.getItem("x-cart");
    const getId = JSON.parse(localStorage.getItem("user"));
    const cartId = JSON.parse(localStorage.getItem("x-cart"));
    const accessToken = localStorage.getItem('access-token');
    if (accessToken) {
      if (getId || cartId) {
        this.fetchShoppingCart({
          id: getId?.id || cartId,
        });
      }
    }
  },
  mounted() {
    if (this.$refs.link) {
      this.$refs.link.$el.children[0].style.letterSpacing = "0.4px";
      this.$refs.link.$el.children[0].style.marginRight = "-4px";
    }
    const reserved = JSON.parse(localStorage.getItem("reservedProductIds") || "[]");
    this.reservedProductIds = reserved;
    this.$root.$on("chanLang", () => {
      this.reRenderComp = false;
      this.$nextTick(() => {
        this.reRenderComp = true;
      });
    });
    this.getDisableProducts;
  },
  methods: {
    ...mapActions("shoppingCart", [
      "createShoppingCart",
      "fetchShoppingCart",
      "addProductToShoppingCart",
      'reserveProductToCart',
      'updateLocalCartProducts'
    ]),
    reservedProduct() {
      this.alreadyReserved = true;
    },
    buyProduct() {
      const externalId = get(this.product, "externalId");
      const currentLanguage = this.$i18n.locale.split('-')[0];
      if (externalId) {
        const url = `https://www.saq.com/${currentLanguage}/${externalId}`;
        window.open(url, '_blank');
      }
    },
    addToCart(e) {
      e.preventDefault();
      const uId = JSON.parse(localStorage.getItem("user"));
      const shoppingCartId =
        get(this.shoppingCart, "id") || localStorage.getItem("x-cart");
      const productPuid = this.product.puid || get(this.product, "erpProduct.puid");
      const quantity = this.model.qty || 1;

      if (!productPuid) {
        // Add-to-cart silently does nothing here: no puid means the product was
        // never enriched with its inventory variant (a known region-switch
        // failure mode). To the customer the button is simply dead.
        reportError("CART_MISSING_PUID", {
          message: "Add to cart aborted: product has no puid",
          data: {
            productId: get(this.product, "id"),
            region: this.countryCode,
            erpProduct: !!get(this.product, "erpProduct"),
          },
        });
        return;
      }
      // Last line of defence against a foreign-company line entering the cart.
      // The listings and carousels are market-scoped again, but a shared or
      // stale URL still opens a product sheet from the other market, and adding
      // it produced two identical wines at two prices in one cart — and an order
      // written against the wrong company. Only refuse when the inventory code
      // is known AND clearly foreign; an unknown/absent code keeps the old
      // behaviour so a degraded CMS response cannot block every add.
      const productInventoryCode =
        get(this.product, "inventory.code") ||
        get(this.product, "erpProduct.inventory.code");
      const marketCodes = getDefaultAvailability(this.countryCode).map((c) =>
        c.toUpperCase()
      );
      if (
        productInventoryCode &&
        !isBoutiqueInventory(productInventoryCode) &&
        marketCodes.indexOf(String(productInventoryCode).toUpperCase()) === -1
      ) {
        reportError("CART_FOREIGN_INVENTORY", {
          message: "Add to cart refused: product inventory is outside this market",
          data: {
            puid: productPuid,
            inventory: productInventoryCode,
            region: this.countryCode,
          },
        });
        this.$store.dispatch("notification/displayNotification", {
          title: this.$i18n.t("shoppingCart.shoppingCartView.foreignInventoryTitle"),
          message: this.$i18n.t("shoppingCart.shoppingCartView.foreignInventory"),
          type: "error",
        });
        return;
      }
      if (shoppingCartId) {
        this.showAddToCartPopup();
        const products = get(this.shoppingCart, "products", []);
        const existingProduct = products.find(
          (p) => p.puid && p.puid === productPuid
        );
        if (existingProduct) {
          // Update existing product quantity
          existingProduct.quantity = quantity;
          this.addProductToShoppingCart({
            id: uId?.id || shoppingCartId,
            product: existingProduct,
          });
        } else if (this.activeAddToCartBtn) {
          this.addProductToShoppingCart({
            id: uId?.id || shoppingCartId,
            product: { puid: productPuid, quantity },
          });
        }
      } else {
        const storedCartProducts =
          JSON.parse(localStorage.getItem("cartProducts" + this.countryCode)) || [];
        const productIdsInCart = storedCartProducts.map((p) => p.puid);
        const getQuantity = get(this.product, "uvc");
        const existingProduct = storedCartProducts.find(
          (p) => p.puid === productPuid
        );
        if (existingProduct) {
          // Update existing product quantity
          existingProduct.quantity += getQuantity * quantity;
          localStorage.setItem(
            "cartProducts" + this.countryCode,
            JSON.stringify(storedCartProducts)
          );
        } else
        
        if (!productIdsInCart.includes(productPuid)) {
          storedCartProducts.push({ puid: productPuid, quantity: getQuantity * quantity, uvc: getQuantity, actualQuantity: quantity });

          localStorage.setItem(
            "cartProducts" + this.countryCode,
            JSON.stringify(storedCartProducts)
          );
          this.updateLocalCartProducts(storedCartProducts);

          if (get(this.product, "erpProduct.quantity.inStock")) {
            this.showAddToCartPopup(); // Show popup
          }
        }
        else {
          // error = true;
          reportError("CART_ADD_NOOP", {
            message: "Product already in local cart; nothing added",
            data: { puid: productPuid, region: this.countryCode },
          });
        }
      }
      this.showAddToCartPopup();
    },
    showAddToCartPopup() {
      if (this.alreadyReserved == false) {
        this.addToCartPopup = true;
        this.addToCartPopupContent = true;
      }
      // setTimeout(() => {
      //   this.addToCartPopup = false;
      // }, 3000);
    },
    showreservePopup() {
      this.addToCartPopupContent = false;
      this.showReservationThanks = true;
      const productPuid = this.product.puid || get(this.product, "erpProduct.puid");
      if (!this.reservedProductIds.includes(productPuid)) {
        this.reservedProductIds.push(productPuid);
        localStorage.setItem("reservedProductIds", JSON.stringify(this.reservedProductIds));
      }
      const customerId = JSON.parse(localStorage.getItem("customer"));
      const uId = JSON.parse(localStorage.getItem("user"));
      if (!customerId && !uId) {
        reportError("RESERVE_NO_IDENTITY", {
          message: "Cannot reserve product: no customer or user in localStorage",
          data: { productId: get(this.product, "id"), puid: productPuid },
        });
        return;
      }
      
      this.reserveProductToCart({
        product: {
          product: {id: this.product?.id},
          customer: {id: customerId},
          qty: this.model.qty || 1,
        },
      }).then((res) => {
        if (res && res.success) {
          this.$store.commit("shoppingCart/addReservedProduct", this.product);
          this.$store.dispatch("shoppingCart/fetchShoppingCart", { id: uId?.id || localStorage.getItem("x-cart") });
        } else {
          reportError("RESERVE_FAILED", {
            message: "reserveProductToCart returned an unsuccessful response",
            data: { productId: get(this.product, "id"), puid: productPuid, response: res },
          });
        }
      });

      setTimeout(() => {
        this.showReservationThanks = false;
        this.addToCartPopup = false;
      }, 3000);
    },

    goTo(path, condition = true) {
      if (condition) {
        var parm = path.split("###");
        this.$router.push({
          name: "product",
          params: {
            slug: parm[0],
            productType: parm[3],
          },
          query: {
            id: parm[2],
            productType: parm[3],
          },
        });
      }
    },
    showAvailableInStore() {
      this.getBotiqueProduct.length > 0 ? (this.showBotiqueList = true) : "";
    },
    gotoProduct() {
      if (this.defaultStore === "Boutiques") {
        return;
      }
      this.goTo(this.defaultStore);
    },
    goAgencyProduct() {
      if (!isEmpty(this.getAgencyProduct)) {
        this.$router.push({
          name: "product",
          params: {
            slug: this.getAgencyProduct[0].slug,
            productType: "",
          },
          query: {
            id: this.getAgencyProduct[0].puid.toString(),
          },
        });
      }
    },
    goToShopping(path, condition = true) {
      if (condition) {
        this.$router.push(path).catch(() => { });
      }
    },
    hideShowpopup(desc) {
      var findATag = desc.search("</a>");
      if (findATag == -1) {
        this.hideShowPopupModel = "hide-showpopup-model";
      }
      this.hideShowPopupModel = "";
    },
    goToLogin(path, condition = true) {
      if (condition) {
        this.$router.push(path).catch(() => { });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";

.light-grey {
  color: $color-on-background-area1;
}

.quantity-label {
  text-transform: uppercase;
  font-size: 10px;
  text-align: left;
  line-height: normal;
  letter-spacing: 1.5px;
}

.nb-item-label {
  font-size: 12px;
  text-align: left;
  line-height: normal;
  letter-spacing: 0.4px;
}

.price-label {
  font-size: 10px;
  font-weight: 300;
  color: rgba(39, 36, 33, 0.7);
  text-align: right;
  line-height: normal;
  letter-spacing: 1.5px;
}

.price {
  font-size: 18px;
  text-align: right;
  line-height: normal;
  letter-spacing: 0.25px;
}

.volume {
  font-size: 14px;
  padding-left: 2px;
}

.add-to-cart__content {
  margin-right: 2px;
}

.el-link.el-link-primary {
  color: $color-primary !important;
}

.el-link-primary.el-link--inner {
  font-family: $font-family;
  color: $color-primary;
  letter-spacing: 0.4px !important;
}

.interrogation-icon {
  width: 12px;
  height: 12px;
  border: 1px solid $color-primary;
  background-color: rgba(255, 255, 255, 0);
  box-sizing: border-box;
  font-family: "Arial Regular", "Arial", sans-serif;
  color: $color-primary;
  text-align: center;
  line-height: normal;
  font-size: 8px;
}

.round {
  /* Safari 3-4, iOS 1-3.2, Android 1.6- */
  -webkit-border-radius: 50%;

  /* Firefox 1-3.6 */
  -moz-border-radius: 50%;

  /* Opera 10.5, IE 9, Safari 5, Chrome, Firefox 4, iOS 4, Android 2.1+ */
  border-radius: 50%;
}

.inventory {
  width: 22px;
  height: 16px;
  border-radius: 2px;
  background-color: rgba(255, 255, 255, 0);
  box-sizing: border-box;
  font-family: "Futura Std ", "Futura Std", sans-serif;
  font-weight: 700;
  color: #fff;
  text-align: center;
  line-height: normal;
  letter-spacing: 0.4px;
  font-size: 12px;
  background-color: #c7c6c4;
  padding: 0px 4px;
  padding-top: 1px;
}

.cart-section .el-button--warning {
  background-color: rgb(163, 28, 37) !important;
  border-color: rgb(163, 28, 37);
  color: #fff;
}

.cart-section .el-button--warning:hover {
  border-color: rgb(163, 28, 37);
  // color: rgb(163, 28, 37);
  background-color: transparent;
}

.cart-section {
  .price-volume {
    margin: 0 0 0 auto;
    display: flex;
    justify-content: space-between;

    .price {
      margin-left: auto;
    }
  }
}

.purchaseLabel {
  .circle {
    color: RGB(191, 145, 52);
    border-color: RGB(191, 145, 52);
  }

  .el-link--warning {
    border: 0;
  }
}

// .questionMark {
//   // margin-left: auto;
//   display: flex;
// }

.add-to-cart-btn:focus {
  background-color: transparent;
  color: #a31c25;
}

.add-to-cart-btn:hover {
  color: #fff;
}

.botique-products {
  border: 1px solid #a31c25;
  width: 203px;
  margin-left: auto;
  display: block;
}

.add-to-cart-modal {
  .success-icon {
    color: rgb(61 199 20);
  }

  .add-to-cart-title {
    color: #000;
  }

  .product-name {
    font-weight: 300;
    font-size: 18px;
    font-style: normal;
    color: rgb(39, 36, 33);
    text-align: left;
    letter-spacing: 0.25px;
  }

  .biologique-logo {
    width: 16px;
  }

  .price-section {
    // position: absolute;
    bottom: 100px;

    .price {
      font-weight: 700;
    }
  }

  .continue-shopping {
    font-size: 16px;
    font-weight: 500;
    font-style: normal;
    color: rgb(163, 28, 37);
    text-align: center;
    letter-spacing: 1.25px;

    &:hover {
      color: #a31c25;
      text-decoration: underline;
    }
  }

  .el-button--warning {
    border-color: #a31c25 !important;

    &:hover {
      background-color: #a31c25 !important;
    }
  }
}

.cart-tip {
  margin-left: 10px;
}

.disable-restro {
  opacity: 0.65;
}

.inventory__label {
  width: fit-content;
  line-height: normal;
  padding: 0px 4px;
  padding-top: 1px;
}

.not-available,
.not-available:focus,
.not-available:hover {
  color: #a31c25;
  background-color: #fff !important;
  border: 1px solid #a31c25 !important;
}
</style>
